<template>
    <div class="container-fluid position-relative bg-BAT-iframe px-0">
        <loading v-if="loading !== 0" class="position-absolute"></loading>
        <iframe v-if="url" class="iframe-pedido" :src="url" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            default: '',
        },
    },
    data() {
        return {
            loading: 0,
        }
    },
    mounted () {
        this.loading = 1
        setTimeout(() => {
            this.loading = 0
        }, 3000);
    },
    methods: {

    },
}
</script>
